module.exports = __webpack_public_path__ + "img/link-document.ebbeb13f.svg";